import { eResultsOptions, getSiteOption } from "./siteOptions";

const helpers = {
  isNumber: function isNumber(n: string | number): boolean {
    return !isNaN(parseFloat(n as string)) && isFinite(n as number);
  },
};

// Lab number validation from query parameters
export const validateLabNumberDigitOnly = (labNumber: string): boolean => {
  if (!labNumber || labNumber === "UNKNOWN") return true;

  // ACL format: XX-XXXXXXX or XX-XXXXXXXX (2 digits, dash, 7-8 digits)
  const aclPattern = /^[0-9]{2}-[0-9]{7,8}$/;

  // SSP format: XX/[SQR]XXXXXX (2 digits, slash, S/Q/R followed by 6 digits)
  const sspPattern = /^[0-9]{2}\/[SQR][0-9]{6}$/;

  return aclPattern.test(labNumber) || sspPattern.test(labNumber);
};

export const validateLabNumber = (labNumber: string): boolean => {
  const pattern = /^[0-9]{2}-[0-9]{7,8}-[A-Z0-9_]{2,3}-[0-9]{1,2}$/;

  // SSP format: XX/[SQR]XXXXXX (2 digits, slash, S/Q/R followed by 6 digits)
  const sspPattern = /^[0-9]{2}\/[SQR][0-9]{6}$/;

  return pattern.test(labNumber) || sspPattern.test(labNumber);
};

export const formatAcc = (accCode?: string, accNamme?: string): string => {
  if(!accCode || !accNamme) return "";
  const hiddenCodes = getSiteOption(eResultsOptions.HIDDEN_ACC_CODES);
  if(Array.isArray(hiddenCodes) && hiddenCodes.includes(accCode)) {
    return "";
  }
  return `at ${accNamme} (${accCode})`;
};

export default helpers;
